import {
  FacetsGetters,
  FacetSearchResult,
  AgnosticCategoryTree,
  AgnosticGroupedFacet,
  AgnosticPagination,
  AgnosticSort,
  AgnosticBreadcrumb,
  AgnosticFacet
} from '@vue-storefront/core';
import type { Facet, FacetSearchCriteria } from '@bee-hole/api';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getAll(params: FacetSearchResult<Facet>, criteria?: FacetSearchCriteria): AgnosticFacet[] {
  return [];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getGrouped(params: FacetSearchResult<Facet>, criteria?: FacetSearchCriteria): AgnosticGroupedFacet[] {
  return [];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getSortOptions(params: FacetSearchResult<Facet>): AgnosticSort {
  return {
    options: [
      {
        type: 'Create Time Asc',
        id: 'create_time.asc',
        value: 'Create_Time_Asc'
      },
      {
        type: 'Create Time Desc',
        id: 'create_time.desc',
        value: 'Create_Time_Desc'
      }
      // {
      //   type: 'price Asc',
      //   id: 'price.asc',
      //   value: 'price_Asc'
      // },
      // {
      //   type: 'price Desc',
      //   id: 'price.desc',
      //   value: 'price_Desc'
      // }
    ],
    selected: '1'
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getCategoryTree(params: FacetSearchResult<Facet>): AgnosticCategoryTree {
  return {
    label: '',
    slug: '',
    items: null,
    isCurrent: false,
    count: 0
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getProducts(params: FacetSearchResult<Facet>): any {
  // console.log('getProducts------', params.data);
  params?.data?.list?.map(product => {
    const imgs = [];
    if (product?.imageUrl) {
      imgs.push({
        small: product?.imageUrl,
        normal: product?.imageUrl,
        big: product?.imageUrl
      });
    }

    if (product?.imageUrl1) {
      imgs.push({
        small: product?.imageUrl1,
        normal: product?.imageUrl1,
        big: product?.imageUrl1
      });
    }

    if (product?.imageUrl2) {
      imgs.push({
        small: product?.imageUrl2,
        normal: product?.imageUrl2,
        big: product?.imageUrl2
      });
    }

    if (product?.imageUrl3) {
      imgs.push({
        small: product?.imageUrl3,
        normal: product?.imageUrl3,
        big: product?.imageUrl3
      });
    }

    if (product?.imageUrl4) {
      imgs.push({
        small: product?.imageUrl4,
        normal: product?.imageUrl4,
        big: product?.imageUrl4
      });
    }
    if (product) {
      product.images = imgs;
    }
  });

  return params?.data?.list;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getPagination(params: FacetSearchResult<Facet>): AgnosticPagination {
  const page = {
    currentPage: params.data?.page || 1,
    totalPages: 1,
    totalItems: params.data?.total || 0,
    itemsPerPage: params.data?.limit || 10,
    pageOptions: []
  };
  if (page.totalPages > 0) {
    page.totalPages = Math.ceil(page.totalItems / page.itemsPerPage);
  }
  return page;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getBreadcrumbs(params: FacetSearchResult<Facet>): AgnosticBreadcrumb[] {
  return [];
}

export const facetGetters: FacetsGetters<Facet, FacetSearchCriteria> = {
  getSortOptions,
  getGrouped,
  getAll,
  getProducts,
  getCategoryTree,
  getBreadcrumbs,
  getPagination
};
